import {
  IGridFlatInventoryItemVenue,
  IInventoryItemVenueVendor,
  IUpdatedInventoryItem,
  IVendorMeasure,
} from '../types';
import { cloneDeep, find, forEach, isEqual, isNil, map, values } from 'lodash';

const getMeasureFromVendor = (
  vendors: IInventoryItemVenueVendor[],
  vendorEntityId: string,
  measureEntityId: string,
): IVendorMeasure => {
  const currentVendor: IInventoryItemVenueVendor = find(
    vendors,
    (vendor: IInventoryItemVenueVendor) =>
      isEqual(vendor.entity_id, vendorEntityId),
  );

  return find(currentVendor.measures, (measure: IVendorMeasure) =>
    isEqual(measure.entity_id, measureEntityId),
  );
};

const markInventoryItemIsUpdated = (
  inventoryItems: IGridFlatInventoryItemVenue[],
  updatedItems: IUpdatedInventoryItem,
): IGridFlatInventoryItemVenue[] => {
  const inventoryItemsClone = cloneDeep(inventoryItems);
  if (!isNil(updatedItems)) {
    const updatedItemEntityIds = map(values(updatedItems), 'item_entity_id');
    forEach(updatedItemEntityIds, (entityId) => {
      const matchItem = find(inventoryItemsClone, { item_entity_id: entityId });
      // Save deleted and modified entity information for list markup modification prompts
      if (isNil(matchItem)) {
        inventoryItemsClone.push({
          item_entity_id: entityId,
          error: true,
        } as IGridFlatInventoryItemVenue);
      } else {
        matchItem.error = true;
      }
    });
  }

  return inventoryItemsClone;
};

export { getMeasureFromVendor, markInventoryItemIsUpdated };
